type ColorCircleProps = {
  color?: string;
  size?: number;
  slot?: string;
};

export function ColorCircle({ color = "transparent", size = 24 }: ColorCircleProps) {
  return (
    <svg
      height={size}
      style={{ display: "block" }}
      viewBox={`0 0 ${size} ${size}`}
      width={size}
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        fill={color}
        r={size / 2}
      />
    </svg>
  );
}
